// Re-eksport typu TaskDTO z api dla spójności nazewnictwa w projekcie
export type { TaskDTO } from '../api/generated/requests/types.gen';

// Opcje statusów zadania dla komponentów formularza
export const TASK_STATUS_OPTIONS = [
  { value: 'TODO', label: 'Do zrobienia' },
  { value: 'IN_PROGRESS', label: 'W trakcie' },
  { value: 'CANCELED', label: 'Anulowane' },
  { value: 'DONE', label: 'Zakończone' }
];


// Opcje priorytetów zadania dla komponentów formularza
export const TASK_PRIORITY_OPTIONS = [
  { value: 'A', label: 'Pilne' },
  { value: 'B', label: 'Ważne' },
  { value: 'C', label: 'Neutralne' },
  { value: 'D', label: 'Opcjonalne' },
  { value: 'E', label: 'Do usunięcia' }
];

export const TASK_TYPE = [
  { value: 'EMAIL', label: 'E-mail' },
  { value: 'PHONE', label: 'Telefon' },
  { value: 'MEETING', label: 'Spotkanie' },
  { value: 'MESSAGE', label: 'Wiadomość' },
  { value: 'OTHER', label: 'Inne' }
];

// Funkcje pomocnicze
export const getStatusLabel = (status?: string): string => {
  const option = TASK_STATUS_OPTIONS.find(opt => opt.value === status);
  return option ? option.label : status || 'Nieznany';
};

export const getPriorityLabel = (priority?: string): string => {
  const option = TASK_PRIORITY_OPTIONS.find(opt => opt.value === priority);
  return option ? option.label : priority || 'Nieznany';
};

export const getTaskTypeLabel = (taskType?: string): string => {
  const option = TASK_TYPE.find(opt => opt.value === taskType);
  return option ? option.label : taskType || 'Nieznany';
};

export const getStatusColor = (status?: string): string => {
  switch (status) {
    case 'TODO': return '#2196f3'; // niebieski
    case 'IN_PROGRESS': return '#ff9800'; // pomarańczowy
    case 'DONE': return '#4caf50'; // zielony
    case 'CANCELED': return '#f44336'; // czerwony
    default: return '#9e9e9e'; // domyślnie szary
  }
};

export const getPriorityColor = (priority?: string): string => {
  switch (priority) {
    case 'A': return '#f44336'; // czerwony - krytyczny
    case 'B': return '#ff9800'; // pomarańczowy - wysoki
    case 'C': return '#2196f3'; // niebieski - średni
    case 'D': return '#4caf50'; // zielony - niski
    case 'E': return '#9e9e9e'; // szary - bardzo niski
    default: return '#9e9e9e'; // domyślnie szary
  }
};

export const getTaskTypeColor = (taskType?: string): string => {
  switch (taskType) {
    case 'EMAIL': return '#1976d2'; // niebieski - email
    case 'PHONE': return '#388e3c'; // zielony - telefon
    case 'MEETING': return '#f57c00'; // pomarańczowy - spotkanie
    case 'MESSAGE': return '#7b1fa2'; // fioletowy - wiadomość
    case 'OTHER': return '#616161'; // szary - inne
    default: return '#9e9e9e'; // domyślnie szary
  }
};
